"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_string_1 = require("query-string");
var buildLinkWithArguments = function (currentURL, linkArguments) {
    if (linkArguments === void 0) { linkArguments = {}; }
    var url = new URL(currentURL, "https://" + process.env.FRAGMENT_HOST);
    var linkAnchor = linkArguments.field_link_anchor, linkHighlight = linkArguments.field_link_highlight, linkSearchfilter = linkArguments.field_link_searchfilter, linkTracking = linkArguments.field_tracking, bonusNumber = linkArguments.field_bonus_number;
    url.hash = query_string_1.stringify(__assign({ anchor: linkAnchor, lmPromo: linkTracking, highlight: linkHighlight, f: linkSearchfilter, BonusNumber: bonusNumber }, query_string_1.parse(url.hash)), { encode: false, sort: false }).replace('anchor=', ''); // for anchor: remove the prefix caused by the object key
    return url.href;
};
exports.default = buildLinkWithArguments;
//# sourceMappingURL=buildLinkWithArguments.js.map